import { Controller, useFormContext } from 'react-hook-form';
// import { FormError } from 'eone-ui/forms/form-error';
import cn from 'classnames';
import { get } from 'lodash-es';
import { Suspense } from 'react';
import type { ControllerFieldState, ControllerProps, ControllerRenderProps } from 'react-hook-form';
import { SCView } from '../view';
import { getFieldTooltip, useStablePlaceholder, useStableValue } from './helper';

interface SCFormFieldProps {
  name: string;
  label?: string;
  max?: number;
  min?: number;
  required?: boolean;
  visible?: boolean;
  disabled?: boolean;
  /* START OF workaround-props for not affecting Searchbar/FilterSelect in `<SCFormFieldSCTable>` */
  disableFormFieldError?: boolean;
  disableSelfStyleOfDisabled?: boolean;
  /* END OF workaround-props for not affecting Searchbar/FilterSelect in `<SCFormFieldSCTable>` */
  defaultValue?: any;
  rules?: ControllerProps['rules'];
  withMarginBottom?: boolean;
  actionButtons?: React.ReactNode;
  secure?: boolean;
  secureReadonly?: boolean;
  Error?: string;
  MaxHeightWithBreadcrumb?: boolean;
  Skeleton?: boolean;
  children?: (props: {
    field: ControllerRenderProps;
    label?: string;
    required?: boolean;
    extraProps?: Record<string, any>;
    actionButtons?: React.ReactNode;
    fieldState?: ControllerFieldState;
  }) => React.ReactNode;
}

const SCFormField = ({
  name,
  disabled,
  disableFormFieldError,
  disableSelfStyleOfDisabled,
  defaultValue,
  withMarginBottom,
  actionButtons,
  visible,
  // label,
  required,
  rules = {},
  children,
  MaxHeightWithBreadcrumb,
}: SCFormFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = !disableFormFieldError && get(errors, name);
  const tooltip = error ? getFieldTooltip(error) : null;
  const extraProps = { ...tooltip };
  const stableExtraProps = useStableValue(extraProps);
  const [domRef, stablePlaceholder] = useStablePlaceholder();

  const style = MaxHeightWithBreadcrumb ? { height: '100%' } : {};

  if (visible != true && visible != undefined) return null;

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={{ ...rules, required }}
      render={({ field, fieldState }) => {
        const fieldDisabled = field.disabled;
        const anyDisabled = disabled || fieldDisabled;
        const styleOfDisabled = !disableSelfStyleOfDisabled && anyDisabled;
        return (
          <SCView
            className={cn({
              'sc-form-field': true, // common class as a helper for testing, etc
              'sc-form-field-disabled': styleOfDisabled,
              'sc-form-field-has-error': error,
            })}
            mb={withMarginBottom ? 4 : undefined}
            ref={domRef}
            style={style}
          >
            {/*
          FIXME: eone-ui crashing issue:
          lazy react-markdown in Tooltip without a Suspense leads to render crash:
          A component suspended while responding to synchronous input...
          */}
            <Suspense fallback={stablePlaceholder}>
              {children?.({
                field: {
                  ...field,
                  disabled: anyDisabled,
                },
                fieldState,
                extraProps: stableExtraProps,
                actionButtons,
              }) || null}
            </Suspense>
            {/* removed in favor of tooltip */}
            {/* {error?.message && <FormError Message={error.message} />} */}
          </SCView>
        );
      }}
    />
  );
};

export { SCFormField };
export type { SCFormFieldProps };
